import HGLink from '@/components/links'
import { menusList } from '@/lib/fetch/menu'
import NavItem from './item'
import More from './more'

export default async function Nav() {
  const menus = await menusList()
  return (
    <nav className='flex-1 hidden md:block'>
      <ul className='flex gap-x-4 lg:gap-x-6 text-[var(--header-text)]/60 font-bold whitespace-nowrap @container'>
        {menus.map((menu, index) => (
          <NavItem key={menu.id} primary={index < 3}>
            <HGLink
              href={
                String(menu.slug).startsWith('/') ? menu.slug : `/${menu.slug}`
              }
              aria-label={`go to ${menu.name}`}
              className='hover:text-[var(--header-text)] transition-colors'
              activeClassName='text-[var(--header-text)]'
            >
              {menu.name}
            </HGLink>
          </NavItem>
        ))}
        <More data={menus} />
      </ul>
    </nav>
  )
}
